module.exports = __webpack_public_path__ + "img/Logo_PCI_DSS.e65c040b.png";